/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ChevronDown, ChevronUp, Search, X } from 'lucide-react'
import { useContext, useEffect, useState, Fragment } from 'react'
import {
  Col,
  Collapse,
  Container,
  Nav,
  OverlayTrigger,
  Popover,
  Row,
  Stack
} from 'react-bootstrap'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import baj_logo from '../../assets/baj_logo.png'
import { UserContext } from '../../context/userContext'
import '../../styles/style.css'
import PurchaseOrderIcon from '../../components/atoms/Icons/PurchaseOrderIcon'
import MaterialRequestIcon from '../../components/atoms/Icons/MaterialRequestIcon'
import ItemIssueIcon from '../../components/atoms/Icons/ItemIssueIcon'
import MaterialIssueIcon from '../../components/atoms/Icons/MaterialIssueIcon'
import DisposalIcon from '../../components/atoms/Icons/DisposalIcon'
import BeritaAcaraIcon from '../../components/atoms/Icons/BeritaAcaraIcon'
import TransferIcon from '../../components/atoms/Icons/TransferIcon'
import ArrivalPlanIcon from '../../components/atoms/Icons/ArrivalPlanIcon'
import InboundIcon from '../../components/atoms/Icons/InboundIcon'
import OutboundPlanIcon from '../../components/atoms/Icons/OutboundPlanIcon'
import OutboundIcon from '../../components/atoms/Icons/OutboundIcon'
import WorkOrderPlanIcon from '../../components/atoms/Icons/WorkOrderPlanIcon'
import ReplenishmentIcon from '../../components/atoms/Icons/ReplenishmentIcon'
import StockAdjustmentIcon from '../../components/atoms/Icons/StockAdjustmentIcon'
import StockOpnameIcon from '../../components/atoms/Icons/StockOpnameIcon'
import MasterIcon from '../../components/atoms/Icons/MasterIcon'
import SettingIcon from '../../components/atoms/Icons/SettingIcon'
import StockLedgerIcon from '../../components/atoms/Icons/StockLedgerIcon'
import DashboardIcon from '../../components/atoms/Icons/DashboardIcon'

function Sidebar(props) {
  const { collapsed } = props
  const headMenuStyle = {
    backgroundColor: 'var(--primary-orange)',
    color: 'white'
  }

  const headMenuStyleCollapsed = {
    backgroundColor: 'var(--primary-orange)',
    color: 'white',
    width: '50px',
    height: '40px'
  }

  const headMenuStyleHover = {
    color: 'var(--primary-grey)'
  }

  const navigate = useNavigate()
  const [state, dispatch] = useContext(UserContext)
  const subMenusData = state.username?.access.reduce((acc, cur) => {
    acc.push({ ...cur, collapse: false })
    return acc
  }, [])

  const [sidebars, setSidebars] = useState([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    if (subMenusData) {
      const hasDashboard = subMenusData.find((m) => m.menu === 'Dashboard')
      if (!hasDashboard) {
        setSidebars([
          {
            menu: 'Dashboard',
            slug: 'dashboard',
            submenu: [],
            sequence: 0,
            collapse: false
          },
          ...subMenusData
        ])
      } else {
        setSidebars(subMenusData)
      }
    }
  }, [state.username?.access])
  const [visiblePopover, setVisiblePopover] = useState(null)
  const [popoverTarget, setPopoverTarget] = useState(null)
  const { pathname } = useLocation()
  const headMenu = pathname.split('/')[1]
  const poHeadMenu = pathname.split('/')[2]
  const routeValue = `${headMenu}/${poHeadMenu}`

  useEffect(() => {
    setSidebars((prevSidebar) =>
      prevSidebar.map((value) =>
        value.menu?.split(' ')[0].toLowerCase() ===
          (headMenu === 'manage' ? 'cms' : headMenu) &&
        /^\/outbound\/plan(\/.*)?$/.test(pathname) === false
          ? { ...value, collapse: true }
          : { ...value, collapse: false }
      )
    )
  }, [headMenu])

  const icons = (value, isActive, subMenu = null) => {
    switch (value) {
      case 'Dashboard':
        return <DashboardIcon isActive={isActive} />
      case 'Purchase Order':
        return <PurchaseOrderIcon isActive={isActive} />
      case 'Material Request':
        return <MaterialRequestIcon isActive={isActive} />
      case 'Item Issue':
        return <ItemIssueIcon isActive={isActive} />
      case 'Material Issue':
        return <MaterialIssueIcon isActive={isActive} />
      case 'Disposal':
        return <DisposalIcon isActive={isActive} />
      case 'Berita Acara':
        return <BeritaAcaraIcon isActive={isActive} />
      case 'Transfer':
        return <TransferIcon isActive={isActive} />
      case 'Arrival Plan':
        return <ArrivalPlanIcon isActive={pathname.includes('arrival')} />
      case 'Inbound':
        return <InboundIcon isActive={pathname.includes('inbound')} />
      case 'Outbound Plan':
        return (
          <OutboundPlanIcon isActive={pathname.includes('outbound/plan')} />
        )
      case 'Outbound':
        return (
          <OutboundIcon
            isActive={
              pathname.includes('outbound') &&
              !pathname.includes('outbound/plan')
            }
          />
        )
      case 'Work Order Plan':
        return <WorkOrderPlanIcon isActive={isActive} />
      case 'Replenishment':
        return <ReplenishmentIcon isActive={isActive} />
      case 'Stock Ledger':
        return <StockLedgerIcon isActive={pathname.includes('stock-ledger')} />
      case 'Stock Opname':
        return (
          <StockOpnameIcon
            isActive={
              pathname.includes('stock-take') ||
              pathname.includes('cycle-count') ||
              pathname.includes('manual-stock-opname') ||
              pathname.includes('packing-stock-opname')
            }
          />
        )
      case 'Stock Adjustment':
        return <StockAdjustmentIcon isActive={isActive} />
      case 'Master':
        return <MasterIcon isActive={pathname.includes('master')} />
      case 'Setting':
        return <SettingIcon isActive={pathname.includes('setting')} />
      case 'CMS':
        return <SettingIcon isActive={pathname.includes('manage')} />
      default:
        return <PurchaseOrderIcon isActive={isActive} />
    }
  }

  const collapseAction = (action) => {
    setSidebars(
      sidebars.map((sidebar) =>
        sidebar.menu === action
          ? { ...sidebar, collapse: !sidebar.collapse }
          : { ...sidebar, collapse: false }
      )
    )
  }

  const popover = (submenu) => (
    <Popover id="popover-basic" onMouseLeave={handlePopoverMouseLeave}>
      <Popover.Body>
        {submenu.map((value, idx) => (
          <div key={value.sequence ?? idx}>
            {value.slug ? (
              <p
                className="fs-6 cursor-pointer"
                role="button"
                onClick={() => {
                  navigate(`/${value.slug}`, { replace: true })
                  setVisiblePopover(null)
                }}
              >
                {value.menu}
              </p>
            ) : (
              <p className="fs-6 cursor-pointer" role="button">
                {value.menu}
              </p>
            )}
          </div>
        ))}
      </Popover.Body>
    </Popover>
  )

  const handlePopoverClick = (event, menu) => {
    const target = event.currentTarget
    setVisiblePopover(visiblePopover === menu ? null : menu)
    setPopoverTarget(target)
  }

  const handleMouseLeave = (event, menu) => {
    // Hide popover only if mouse leaves both the trigger and the popover
    if (
      event.relatedTarget &&
      event.relatedTarget.closest('.popover') === null
    ) {
      setVisiblePopover(null)
    }
  }

  const handlePopoverMouseLeave = (event) => {
    if (event.relatedTarget && !event.relatedTarget.closest('.btn')) {
      setVisiblePopover(null)
    }
  }

  const regexSidebarActive = (menu, pathname) => {
    const pattern = menu.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const patternRegex = new RegExp(`^${pattern}(\\/.*)?$`)
    return patternRegex.test(pathname)
  }

  const filteredSidebars = sidebars
    .map((sidebar) => {
      if (!search.trim()) return sidebar
      const lowerSearch = search.trim().toLowerCase()

      const isMenuMatch = sidebar.menu.toLowerCase().includes(lowerSearch)

      if (isMenuMatch) {
        return { ...sidebar, collapse: true }
      }

      if (sidebar.submenu && sidebar.submenu.length > 0) {
        const filteredSub = sidebar.submenu.filter((s) =>
          s.menu.toLowerCase().includes(lowerSearch)
        )
        if (filteredSub.length > 0) {
          return { ...sidebar, submenu: filteredSub, collapse: true }
        }
      }

      return null
    })
    .filter(Boolean)

  return (
    <>
      <Container className="mt-3 ms-1 overflow-y-auto overflow-x-hidden">
        <Stack className="mb-4">
          <img src={baj_logo} alt="baj" style={{ width: '80%' }} />
        </Stack>
        {collapsed && (
          <div className="px-3 mb-4">
            <div
              className="d-flex align-items-center"
              style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                padding: '8px 12px',
                border: '1px solid #e9ecef'
              }}
            >
              <Search size={16} color="#adb5bd" />
              <input
                type="text"
                placeholder="Search menu..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: 'none',
                  backgroundColor: 'transparent',
                  fontSize: '14px',
                  width: '100%',
                  outline: 'none',
                  marginLeft: '8px',
                  color: '#495057'
                }}
              />
              {search && (
                <X
                  size={16}
                  color="#adb5bd"
                  style={{ cursor: 'pointer', marginLeft: '4px' }}
                  onClick={() => setSearch('')}
                />
              )}
            </div>
          </div>
        )}
        <Row>
          <>
            {filteredSidebars?.map((sidebar, index) => (
              <Fragment key={sidebar.menu || index}>
                {!sidebar.submenu.length ? (
                  <Col
                    md={12}
                    className={`mb-3 ${
                      !collapsed ? 'd-flex justify-content-center' : ''
                    }`}
                  >
                    <Row
                      style={
                        regexSidebarActive(`/${sidebar.slug}`, pathname)
                          ? collapsed
                            ? headMenuStyle
                            : headMenuStyleCollapsed
                          : headMenuStyleHover
                      }
                      className="pt-2 pb-2 rounded-3"
                    >
                      <Col
                        md={12}
                        onClick={() => {
                          navigate(`/${sidebar.slug}`, { replace: true })
                          setVisiblePopover(null)
                        }}
                        style={{ cursor: 'pointer' }}
                        className={`${
                          !collapsed
                            ? 'd-flex flex-column items-content-center justify-content-center h-full'
                            : ''
                        }`}
                      >
                        <div
                          className={`d-flex ${
                            collapsed ? 'flex-row ms-1' : 'flex-column'
                          } align-items-center justify-content-start`}
                        >
                          <>
                            {icons(
                              sidebar.menu,
                              regexSidebarActive(`/${sidebar.slug}`, pathname)
                            )}
                          </>
                          {collapsed && (
                            <small
                              className={`ms-3 fw-bold cursor-pointer ${
                                !collapsed ? 'text-center mt-2' : ''
                              }`}
                              style={{
                                fontSize: `${collapsed ? '14px' : '12px'}`
                              }}
                            >
                              {sidebar.menu}
                            </small>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <Fragment>
                    <Col
                      md={12}
                      onClick={() => {
                        collapseAction(sidebar?.menu)
                      }}
                      role="button"
                      className={`pointer-auto mb-3 ${
                        !collapsed ? 'd-flex justify-content-center' : ''
                      }`}
                    >
                      <Row
                        style={
                          headMenu ===
                            sidebar?.submenu[0].slug?.split('/')[0] &&
                          // pathname !== '/outbound/plan'
                          /^\/outbound\/plan(\/.*)?$/.test(pathname) === false
                            ? collapsed
                              ? headMenuStyle
                              : headMenuStyleCollapsed
                            : headMenuStyleHover
                        }
                        className="pt-2 pb-2 rounded-3"
                      >
                        {collapsed && (
                          <>
                            <Col md={!collapsed ? 12 : 10}>
                              <div className="ms-1 d-flex align-items-center">
                                {icons(
                                  sidebar.menu,
                                  regexSidebarActive(
                                    `/${sidebar.slug}`,
                                    pathname
                                  )
                                )}
                                <small className="ms-3 fw-bold fs-6">
                                  {sidebar.menu}
                                </small>
                              </div>
                            </Col>
                            <Col md={2} className="me-auto">
                              {sidebar.collapse ? (
                                <ChevronUp size={16} />
                              ) : (
                                <ChevronDown size={16} />
                              )}
                            </Col>
                          </>
                        )}
                        {!collapsed && (
                          <OverlayTrigger
                            show={visiblePopover === sidebar.menu}
                            placement="right"
                            overlay={popover(
                              sidebar.submenu.sort(
                                (a, b) => a.sequence - b.sequence
                              )
                            )}
                          >
                            <Col
                              md={12}
                              onClick={(e) =>
                                handlePopoverClick(e, sidebar.menu)
                              }
                              onMouseEnter={(e) =>
                                handlePopoverClick(e, sidebar.menu)
                              }
                              onMouseLeave={(e) =>
                                handleMouseLeave(e, sidebar.menu)
                              }
                              className="d-flex flex-column items-content-center justify-content-center h-full"
                            >
                              <div className="d-flex justify-content-center items-content-center gap-2">
                                {icons(
                                  sidebar.menu,
                                  regexSidebarActive(
                                    `/${sidebar.slug}`,
                                    pathname
                                  )
                                )}
                              </div>
                            </Col>
                          </OverlayTrigger>
                        )}
                      </Row>
                    </Col>
                    {collapsed && (
                      <Col md={12} className={`${collapsed ? 'ms-4' : 'ms-2'}`}>
                        <Collapse in={sidebar.collapse ? true : false}>
                          <div id={sidebar.menu}>
                            <Row>
                              {sidebar.submenu
                                .sort((a, b) => a.sequence - b.sequence)
                                .map((submenu, index) => (
                                  <Nav.Link
                                    className="mb-3"
                                    onClick={() =>
                                      submenu.slug
                                        ? navigate(`/${submenu.slug}`, {
                                            replace: true
                                          })
                                        : null
                                    }
                                    key={`sub-menu-${index}`}
                                  >
                                    <small
                                      className={
                                        submenu.slug &&
                                        (routeValue ===
                                          `${submenu.slug?.split('/')[0]}/${
                                            submenu.slug?.split('/')[1]
                                          }` ||
                                          pathname.includes(submenu.slug))
                                          ? `text-orange fw-bold`
                                          : 'text-secondary'
                                      }
                                      style={{
                                        fontSize: `${
                                          collapsed ? '14px' : '12px'
                                        }`
                                      }}
                                    >
                                      {submenu.menu}
                                    </small>
                                  </Nav.Link>
                                ))}
                            </Row>
                          </div>
                        </Collapse>
                      </Col>
                    )}
                  </Fragment>
                )}
              </Fragment>
            ))}
          </>
        </Row>
      </Container>
    </>
  )
}

export default Sidebar
